import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

const root = createRoot(document.getElementById("root"));

root.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>
);
